import React, { useState } from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

interface WidgetSelectorProps {
  widgetsVisible: boolean;
  setWidgetsVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const WidgetSelector: React.FC<WidgetSelectorProps> = ({
  widgetsVisible,
  setWidgetsVisible,
}) => {
  const handleToggle = () => {
    setWidgetsVisible(prev => !prev);
  };
  
  return (
    <div className="flex justify-center w-[100px] bg-teal-100 bg-opacity-80 rounded-full">
      <Button
        onClick={handleToggle}
        startIcon={widgetsVisible  ? <VisibilityOffIcon /> : <VisibilityIcon />}
        sx={{
          border: "0.5px solid rgba(97, 179, 255, 0.5)",
          backgroundColor: "rgb(0,0,0)",
          height: "35px",
          color: "#ffffff",
          borderRadius: "20px",
          paddingX: "20px",
          textTransform: "capitalize",
        }}
      >
        {widgetsVisible  ? "Widgets" : "Widgets"}
      </Button>
    </div>
  );
};

export default WidgetSelector;
